
const REQUEST_CODE = {
    CODE_TIMEOUT:'TIMEOUT',
    CODE_SUCCESS: 0,
    CODE_UNAUTHORIZED: 2003,
    CODE_PARAM_IS_WRONG: "A00001",
    CODE_REQUEST_FAILURE: "A00003",
    CODE_NEED_CAPTCHA: 'P00107',
    CODE_LOGIN_FAILED: 'P00117'
}

const REQUEST_CODE_STR = {
    [REQUEST_CODE.CODE_TIMEOUT] : '请求超时',
    [REQUEST_CODE.CODE_SUCCESS]: '请求成功',
    [REQUEST_CODE.CODE_UNAUTHORIZED]: '未授权',
    [REQUEST_CODE.CODE_PARAM_IS_WRONG]: '参数错误',
    [REQUEST_CODE.CODE_REQUEST_FAILURE]: '请求失败',
    [REQUEST_CODE.CODE_NEED_CAPTCHA]: '需要验证码',
    [REQUEST_CODE.CODE_LOGIN_FAILED]: '登录失败'
}

const TOPIC_MAP = {
    1:'其他',
    2:'找失主',
    3:'我是失主',
    4:'闲置转卖',
    5:'求购',
    6:'求合租',
    7:'招租'
};

const SOLVED_STR = {
    1:'已解决',
    2:'已找到',
    3:'已找到',
    4:'已卖出',
    5:'已买到',
    6:'已找到',
    7:'已招到',

}

const POST_STATUS = {
    PUBLISHED:1,
    COMPLETED:2,
    USER_DELETED:3,
};

const QUESTION_TYPE = {
    INPUT:'1',
    SELECT:'2',
    MULTI_SELECT:'3'
};

const INPUT_TYPE = {
    STRING:'1',
    NUMBER:'0'
}

module.exports = {
    reverse(map){
        const res = {};
        for(var k in map){
            res[map[k]] = k;
        }
        return res;
    },
    ROUTE_META:{
        auth:true,
        title:'',
        sidebar:true
    },
    REQUEST_CODE_STR,
    REQUEST_CODE,
    TOPIC_MAP,
    POST_STATUS,
    SOLVED_STR,
    QUESTION_TYPE,
    INPUT_TYPE,
};


// WEBPACK FOOTER //
// src/lib/const.js